module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/step_icon-37c756132229a057774beb44e38e229a.png";